import { createSignalRContext } from "react-signalr";

const SignalRContext = createSignalRContext();

export default SignalRContext;
